import React from 'react';
import styles from './Button.module.css'; //styles
import helpers from '../helpers.js';
import Icon from './Icon.js';



/*

<img/>
<div className="squareClassAndA"/>
    BUTTON
        props:
            name: str, name and label of input
            placeholder: str, placeholder text
            labelStyle: default is on the left, top has the label above the input
            iconName: Icon name from react-icons (e.g., "FaHome")
            iconPosition: "left" or "right" (default: "left")
            value: input value (state) from parent
            onPress: setter from parent
            customStyle: TODO based on future requirements
*/
const Button = (props) => {

    let colorString = "Container" + props.color; //ContainerCoal

    const renderContent = () => {
        const text = props.selected ? props.nameSelected : props.name;
        
        if (!props.iconName) {
            return text;
        }

        const icon = <Icon name={props.iconName} size={props.iconSize} className={styles.buttonIcon} />;
        
        if (props.iconPosition === "right") {
            return (
                <span className={styles.buttonContent}>
                    {text}
                    {icon}
                </span>
            );
        }
        
        return (
            <span className={styles.buttonContent}>
                {icon}
                {text}
            </span>
        );
    };

    const handleKeyDown = (event) => {
        if (props.disabled || (event.key !== "Enter" && event.key !== " ")) return;
        event.preventDefault();
        // Space fires on keyup, matching native buttons; repeats would re-submit.
        if (event.key === " " || event.repeat) return;
        props.onPress?.(event);
    };

    const handleKeyUp = (event) => {
        if (props.disabled || event.key !== " ") return;
        event.preventDefault();
        props.onPress?.(event);
    };

    return(
            <div style={props.customStyle} className={styles.ButtonContainer}>
                <div
                    role="button"
                    tabIndex={props.disabled ? -1 : 0}
                    aria-disabled={props.disabled || undefined}
                    className={helpers.clx(styles.Container, props.disabled ? styles.ContainerDisabled : "", styles[colorString], props.selected ? styles.buttonSelected : "")}
                    onClick={!props.disabled ? props.onPress: null}
                    onKeyDown={handleKeyDown}
                    onKeyUp={handleKeyUp}
                >
                    {renderContent()}
                 </div>
            </div>
    )
}

Button.defaultProps = {
    name: 'InputName',
    disabled: false,
    color: "Leaf",
    onPress: console.log("Change onReleaseProp"), //set setState from parent
    iconName: "", //react-icons icon name (e.g., "FaHome")
    iconSize: 18,
    iconPosition: "left", // "left" or "right"
    customStyle: {},
    selected: false,
    nameSelected: ""
};

export default React.memo(Button);